import {
  Component,
  OnInit,
  ViewChild,
  Inject,
  ChangeDetectorRef
} from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { Subject ,  Subscription } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef
} from "@ng-bootstrap/ng-bootstrap";
import { logbaseService } from "../../services/logbase.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { map } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { dateFormatPipe } from "../../pipes/dateFormatPipe";
import { CustomValidators } from "../../directives/custom-validator.directive";
import { TranslateService } from "@ngx-translate/core";

import { NgbPanelChangeEvent } from "@ng-bootstrap/ng-bootstrap";
import { MatTableDataSource } from "@angular/material/table";

const OPERATION_TYPE = "Supplier To Supplier";

export interface NewParts
{
  partNumber:any;
  partName:any;
  updatedDate:any;
  assignedDate:any;
  dueDated:any;
}

export interface InProgress
{
  partNumber:any;
  partName:any;
  updatedDate:any;
  assignedDate:any;
  dueDate:any;
}

export interface UnderReview
{
  partNumber:any;
  partName:any;
  updatedDate:any;
  assignedDate:any;
  dueDate:any;

}

export interface Rejected
{
  partNumber:any;
  partName:any;
  updatedDate:any;
  assignedDate:any;
  comments:any;
}

class toDO {
  partNo: number;
  packageID: string;
  partName: string;
  assignedDate: string;
  lastUpdate: string;
  dueDated: string;
  history: string;
}

@Component({
  selector: "app-todo",
  templateUrl: "./todo.component.html",
  styleUrls: ["./todo.component.scss"]
})
export class TodoComponent implements OnInit {
  closeResult: string;
  parts: any;
  sub: Subscription;
  delPlantOpt = ["T", "B", "N", "Z", "Others"];
  rackPattern = /^\d{2}$/;
  levelPattern = /^\d{1}$/;
  processCodePattern = /^[a-zA-Z0-9]{1}$/;
  processNamePattern = /^[a-zA-Z0-9]{2}$/;
  partIdentifierPattern = /^[a-zA-Z0-9]{1}$/;
  opmSupplierCodeDropdownData: any = [];
  opmDeliveryPointDropdownData: any = [];
  opmDSupplierCodeFilter;
  opmDeliveryPointFilter;
  disableNextProcessSearch = true;
  opmScDpShow: boolean = false;

  supplierCodeSelectionArray: any = [];
  deliveryPointSelectionArray: any = [];
  ovarAllAction: boolean = true;

  //Accordion active IDs
  activeIds: string[] = ["static-1"];

  opsupplierCode;
  opDeliveryPoint;

  //ng-table code
  public rows: Array<any> = [];

  public newPart_columns: Array<any> 

  
  dataSource_newparts: MatTableDataSource<NewParts[]>;
  dataSource_inprogress: MatTableDataSource<InProgress[]>;
  dataSource_underReview: MatTableDataSource<UnderReview[]>;
  dataSource_rejected: MatTableDataSource<Rejected[]>;


  newparts_data:any[]=['partNumber','partName','assignedDate','updatedDate','dueDate']
  inprogress_data:any[]=['partNumber','partName','assignedDate','updatedDate','dueDate']
  underReview_data:any[]=['partNumber','partName','assignedDate','updatedDate','dueDate']
  rejected_data:any[]=['partNumber','partName','assignedDate','updatedDate','comments']
  public inprogress_columns: Array<any> 

  public underReview_columns: Array<any> 
  public rejected_columns: Array<any> 
  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;

  public newPart_config: any 

  public inprogress_config: any 

  public underReview_config: any

  public rejected_config: any 

  private data: Array<any> = [];
  userDetails: string;
  userDetJson: any;
  userRoleID: any;
  userSuppCode: any;
  lineNos: any;
  userRoleName: any;
  loginId: any;
  lineNumbers: any;
  groupNumbers: any;
  suppCodeVal: any;
  suppCodeList: any;
  supplierCodes: any;
  allsuppCode: any[];
  delPointList: any[];
  dropdownSettings2: any;
  dropdownSettings: any;
  dropdownSettings3: any;
  dropdownSettings4: any;
  groupDropdownList: any;
  lineNoList: any[];
  inProgress_columns: any;
  rej_columns: any;
  modalRef: NgbModalRef;
  filterSuppCode: any = [];
  newPartsModelData: any[];
  newPartsAccData: any[];
  newpartslength: any;
  newPartsRow: any;
  statusOption: any;
  showStatusComment: boolean;
  pkgComment: string;
  pkgCommentError: boolean;
  ipPartsAccData: any[];
  ipPartsModelData: any[];
  ippartslength: any;
  inProgressRow: any;
  urPartsModelData: any[];
  urPartsAccData: any[];
  urpartslength: any;
  underReviewRow: any;
  rejectedRow: any;
  supPoint: any = [];
  lineNoFilter: any;
  rejPartsModelData: any[];
  rejPartsAccData: any[];
  rejpartslength: any;
  rej_length: any;
  srch_newpart:any;
  srch_underReview:any;
  srch_rejected:any;
  srch_inprogress:any;


  userOperationType: string;
  checkOperationType: boolean;

  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private document: any,
    private modalService: NgbModal,
    private logbaseService: logbaseService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService
  ) {
    this.inprogress_columns= [
      { title: this.translate.instant("PARTNO"), name: "partNumber" },
      { title: "Part Name", name: "partName" },
      { title: "Assigned Date", name: "assignedDate" },
      { title: "Last Update", name: "updatedDate" },
      { title: "Due Date", name: "dueDated" }
    ];
    this.newPart_columns= [
      { title: this.translate.instant("PARTNO"), name: "partNumber" },
      { title: "Part Name", name: "partName" },
      { title: "Assigned Date", name: "assignedDate" },
      { title: "Last Update", name: "updatedDate" },
      { title: "Due Date", name: "dueDated" }
    ];
    this.underReview_columns= [
      { title: this.translate.instant("PARTNO"), name: "partNumber" },
      { title: "Part Name", name: "partName" },
      { title: "Assigned Date", name: "assignedDate" },
      { title: "Last Update", name: "updatedDate" },
      { title: "Due Date", name: "dueDated" }
    ];
    this.newPart_config= {
      paging: true,
      sorting: { columns: this.newPart_columns },
      filtering: { filterString: "" },
      className: ["table-striped", "table-bordered"]
    };
    this.rejected_columns= [
      { title: this.translate.instant("PARTNO"), name: "partNumber" },
      { title: "Part Name", name: "partName" },
      { title: "Assigned Date", name: "assignedDate" },
      { title: "Last Update", name: "updatedDate" },
      { title: "Comments", name: "comments" }
    ];
    this.inprogress_config= {
      paging: true,
      sorting: { columns: this.inprogress_columns },
      filtering: { filterString: "" },
      className: ["table-striped", "table-bordered"]
    };
    this.underReview_config = {
      paging: true,
      sorting: { columns: this.underReview_columns },
      filtering: { filterString: "" },
      className: ["table-striped", "table-bordered"]
    };
    this.rejected_config= {
      paging: true,
      sorting: { columns: this.rejected_columns },
      filtering: { filterString: "" },
      className: ["table-striped", "table-bordered"]
    };
    this.userDetails = localStorage.getItem("userDetails");
    this.userDetJson = JSON.parse(this.userDetails);
    this.userRoleID = this.userDetJson.userRoleMappings[0].roleId;
    this.userSuppCode = this.userDetJson.supplierCode;
    this.lineNos = this.userDetJson.lineNumbers;
  }

  ngOnInit(): void {
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    this.userRoleID = userDetJson.userRoleMappings[0].roleId;
    this.userRoleName = userDetJson.userRoleMappings[0].roleName;
    this.loginId = userDetJson.loginId;
    this.userSuppCode = userDetJson.supplierCode;
    this.lineNumbers = userDetJson.lineNumbers;
    this.groupNumbers = userDetJson.groupNumbers;
    this.userOperationType = userDetJson.operationType;
    this.checkOperationType =
      this.userRoleID === 4 && this.userOperationType === OPERATION_TYPE
        ? true
        : false;
    this.opsupplierCode = this.userDetJson.operationManagerSupplierCode;
    this.opDeliveryPoint = this.userDetJson.operationManagerdeliveryPointMaster;

    this.getOPMSupplierCodes();
    this.getDeliveryPoint();
    if (this.opmDeliveryPointDropdownData?.length > 0) {
      this.opmDeliveryPointFilter = [...this.opmDeliveryPointDropdownData]; // Select all
      this.onOMDeliveryPointChange(this.opmDeliveryPointFilter); // Optional: trigger selection logic
    }
    if (this.opmDeliveryPointDropdownData.length > 0) this.opmScDpShow = true;

    if (userDetJson.supplierCode) {
      this.suppCodeVal = userDetJson.supplierCode.toString();

      let suppCodeListArr = [];
      // To show supplier codes in supplier dropdown list for SM, log
      this.suppCodeList = this.suppCodeVal.split(",");
      this.suppCodeList.forEach(function(value, key) {
        suppCodeListArr.push({ id: key + 1, itemName: value });
      });
      this.suppCodeList = suppCodeListArr;
      let selectedSuppCode = JSON.parse(localStorage.getItem("todoSuppCode"));
       this.supPoint = selectedSuppCode;
      console.log("suppCodeList",this.suppCodeList)
      // Display all supplier code for logistic admin

      if (
        this.suppCodeList[0].itemName == "ALL" ||
        this.suppCodeList[0].itemName == "null" ||
        this.suppCodeList[0].itemName == ""
      ) {
        //Get all supplier codes starts

        this.logbaseService.getSupplierMasterData().subscribe(result => {
          this.supplierCodes = result.response;
          let suppCodeListArr = [];
          this.supplierCodes.forEach(function(value, key) {
            suppCodeListArr.push({ id: key + 1, itemName: value.supplierCode });
          });
          this.allsuppCode = suppCodeListArr;
          this.suppCodeList = this.allsuppCode;
        });
      }
    }

    // Get delivery points only if it is operation login to display the delivery point for filtering
    this.delPointList = [];

    if (this.userRoleID == 4) {
      this.getLineNos();
    }

    if (this.userRoleID == 4 && this.userOperationType === OPERATION_TYPE) {
      this.initPagingtable();
    }
    this.dropdownSettings2 = {
      singleSelection: false,
      text: this.translate.instant("Select"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      // classes: "custom-class",
      itemsShowLimit: 2,
      idField: 'id',
      textField: 'itemName',
      enableCheckAll: true,
      enableSearchFilter: true,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search',
      clearSearchFilter: true,
      limitSelection: 60
    };
    // Angular2 multi select settings and config
    this.dropdownSettings = {
      singleSelection: false,
      text: this.translate.instant("Select"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      // classes: "custom-class",
      idField: 'id',
      textField: 'itemName',
      itemsShowLimit: 3,
      enableCheckAll: true,
      enableSearchFilter: true,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search',
      clearSearchFilter: true,
      limitSelection: 10
    };

    this.dropdownSettings3 = {
      singleSelection: false,
      text: this.translate.instant("Select"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      // classes: "custom-class",
      idField: 'id',
      textField: 'itemName',
      itemsShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search',
      clearSearchFilter: true,
      limitSelection: 60
    };

    this.dropdownSettings4 = {
      singleSelection: false,
      text: this.translate.instant("Select"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      // classes: "custom-class",
      idField: 'id',
      textField: 'itemName',
      itemsShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search',
      clearSearchFilter: true,
      limitSelection: 60
    };

    /* if (this.userRoleID == 1) {
      this.initPagingtable();
    }*/

    if (this.userRoleID == 11) {
      this.logbaseService.getGroupNumberMasterData().subscribe(result => {
        this.groupDropdownList = result.response;
      });
    }
  }

  ngAfterViewInit() {
    
    let selectedLineNo = JSON.parse(localStorage.getItem("todoLineNo"));
    this.lineNoFilter = selectedLineNo;
    let selectedDp = JSON.parse(localStorage.getItem("toDoDeliveryPoint"));
    this.opmDeliveryPointFilter = selectedDp;
    this.deliveryPointSelectionArray = selectedDp;
    //toDoDeliveryPoint
    this.initPagingtable();
  }

  getLineNos() {
    this.spinner.show();
    let lineNoArr = [];
    // this.logbaseService.getLineNumbers().subscribe(result => {
    //   result.response.forEach(function (value, key) {
    //     lineNoArr.push({ id: key + 1, itemName: value.lineNumber });
    //   });
    //   this.lineNoList = lineNoArr;
    // });

    // Get line number for Operation user login details
    this.lineNumbers.forEach(function(value, key) {
      lineNoArr.push({ id: key + 1, itemName: value });
    });
    this.lineNoList = lineNoArr;
    console.log("lineNoList",this.lineNoList)
    this.spinner.hide();
  }

  getOPMSupplierCodes() {
    this.spinner.show();
    let opsuppCodeArr = [];
    // Get line number for Operation user login details
    console.log("supplier code",this.opsupplierCode)
    if(this.opsupplierCode != null){
      this.opsupplierCode.forEach(function(value, key) {
        opsuppCodeArr.push({ id: key + 1, itemName: value });
      });
    }
    this.opmSupplierCodeDropdownData = opsuppCodeArr;
    this.spinner.hide();
  }

  getDeliveryPoint() {
    this.spinner.show();
    let deliveryPointArr = [];
    // Get line number for Operation user login details
    if( this.opDeliveryPoint != null)
      this.opDeliveryPoint.forEach(function(value, key) {
        deliveryPointArr.push({ id: key + 1, itemName: value });
      });
    this.opmDeliveryPointDropdownData = deliveryPointArr;

    this.spinner.hide();
  }

  open(history) {
    this.modalService.open(history).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  openDetail(detailPage) {
    this.newPart_columns = [
      { title: this.translate.instant("PARTNO"), name: "partNumber" },
      { title: this.translate.instant("PARTNAME"), name: "partName" },
      { title: this.translate.instant("ASSIGNEDDATE"), name: "assignedDate" },
      { title: this.translate.instant("LASTUPDATE"), name: "updatedDate" },
      { title: this.translate.instant("DUEDATE"), name: "dueDated" }
    ];
    this.inProgress_columns = [
      { title: this.translate.instant("PARTNO"), name: "partNumber" },
      { title: this.translate.instant("PARTNAME"), name: "partName" },
      { title: this.translate.instant("ASSIGNEDDATE"), name: "assignedDate" },
      { title: this.translate.instant("LASTUPDATE"), name: "updatedDate" },
      { title: this.translate.instant("DUEDATE"), name: "dueDate" }
    ];
    this.underReview_columns = [
      { title: this.translate.instant("PARTNO"), name: "partNumber" },
      { title: this.translate.instant("PARTNAME"), name: "partName" },
      { title: this.translate.instant("ASSIGNEDDATE"), name: "assignedDate" },
      { title: this.translate.instant("LASTUPDATE"), name: "updatedDate" },
      { title: this.translate.instant("DUEDATE"), name: "dueDated" }
    ];
    this.rejected_columns = [
      { title: this.translate.instant("PARTNO"), name: "partNumber" },
      { title: this.translate.instant("PARTNAME"), name: "partName" },
      { title: this.translate.instant("ASSIGNEDDATE"), name: "assignedDate" },
      { title: this.translate.instant("LASTUPDATE"), name: "updatedDate" },
      { title: this.translate.instant("COMMENTS"), name: "comments" }
    ];
    this.modalRef = this.modalService.open(detailPage, {
      size: "lg",
      windowClass: "detail-modal",backdrop:false
    });
    // this.modalRef.result.then(result => {
    //   this.closeResult = `Closed with: ${result}`;
    // });

    this.modalRef.result.then(
      () => {
        //When user closes
        // Reset Approved parts details and search string when modal is closed

        this.newPart_config.filtering.filterString = "";
        this.inprogress_config.filtering.filterString = "";
        this.underReview_config.filtering.filterString = "";
        this.rejected_config.filtering.filterString = "";

        // To reset the table after close of modal popup
        if (detailPage._def.references.newDetailPage == 2) {
          this.onChangeNewPartTable(this.newPart_config, true);
        } else if (detailPage._def.references.inProgressdetailPage == 2) {
          this.onChangeInprogressTable(this.inprogress_config, true);
        } else if (detailPage._def.references.underReviewPage == 2) {
          this.onChangeUnderReviewTable(this.underReview_config, true);
        } else if (detailPage._def.references.rejectedDetailPage == 2) {
          this.onChangeRejectedTable(this.rejected_config, true);
        }
      },
      () => {
        //When user closes
        // Reset Approved parts details and search string when modal is closed

        this.newPart_config.filtering.filterString = "";
        this.inprogress_config.filtering.filterString = "";
        this.underReview_config.filtering.filterString = "";
        this.rejected_config.filtering.filterString = "";

        // To reset the table after close of modal popup
        if (detailPage._def.references.newDetailPage == 2) {
          this.onChangeNewPartTable(this.newPart_config, true);
        } else if (detailPage._def.references.inProgressdetailPage == 2) {
          this.onChangeInprogressTable(this.inprogress_config, true);
        } else if (detailPage._def.references.underReviewPage == 2) {
          this.onChangeUnderReviewTable(this.underReview_config, true);
        } else if (detailPage._def.references.rejectedDetailPage == 2) {
          this.onChangeRejectedTable(this.rejected_config, true);
        }
      }
    );
  }
  openDetailView(detailPage) {
    this.modalRef = this.modalService.open(detailPage, {
      size: "lg",
      windowClass: "detail-modal",backdrop:false
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  todoPkgRoute(item) {
    localStorage.setItem("partsData", JSON.stringify(item));
    this.router.navigate(["/partDetails/partsInfo/" + item.packageId]);
  }

  todoViewAllPkgRoute(item) {
    localStorage.setItem("partsData", JSON.stringify(item));
    this.modalRef.close();
    this.router.navigate(["/partDetails/partsInfo/" + item.packageId]);
  }

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any, col: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = col || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== "" && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === "desc" ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === "asc" ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any, tableColumn: any): any {
    let filteredData: Array<any> = data;
    let tblCol = tableColumn;
  
    tblCol.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          const value = item[column.name];
          return value != null && value.toString().match(column.filtering.filterString);
        });
      }
    });
  
    if (!config.filtering) {
      return filteredData;
    }
  
    if (config.filtering.columnName) {
      return filteredData.filter((item: any) => {
        const value = item[config.filtering.columnName];
        return value != null && value.toString().match(config.filtering.filterString);
      });
    }
  
    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      tblCol.forEach((column: any) => {
        const value = item[column.name];
        if (value != null && value.toString().match(config.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
  
    filteredData = tempArray;
  
    return filteredData;
  }
  
  public onChangeNewPartTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {


    var pageNo;
    var sortData = {
      name: "",
      sort: ""
    };

    var selectSuppCode = [],
      selectLineNo = [],
      userSuppCode,
      lineNumbers;

    var dateFormatPipeFilter = new dateFormatPipe();

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.newPart_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.newPart_config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.newPart_config.sorting.columns.forEach(function(value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
        if (sortData.sort == "asc") {
          sortData.sort = "ASC";
        } else if (sortData.sort == "desc") {
          sortData.sort = "DESC";
        }
      }
    });

    //Get Selected Supplier Code
    if (this.userRoleID == 1) {
      this.userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function(value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    if (this.lineNoFilter) {
      this.lineNoFilter.forEach(function(value, key) {
        selectLineNo.push(value.itemName);
      });

      if (selectLineNo.length > 0) {
        lineNumbers = selectLineNo;
      }
    }

    if (lineNumbers == null) {
      lineNumbers = [];
    }

    var dataToSend = {
      pageNum: pageNo,
      partStatus: "new",
      roleId: this.userRoleID,
      // searchValue: this.newPart_config.filtering.filterString,
      searchValue:this.srch_newpart,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      supplierCodes: this.userSuppCode,
      lineNumbers: lineNumbers
    };
    this.spinner.show();
    this.logbaseService
      .getNewPartsTodoPaginated(dataToSend)
      .subscribe(result => {
        this.parts = result;
        var partArr;
        var newPartArr;
        var partsData = [];
        var newPartArrData = [];

        if (this.parts) {
          this.parts.response.content.forEach(function(value, key) {
            partArr = {
              partNumber:
                // '<a class="partno_column" href="#/partDetails/partsInfo/' +
                // value.packageId +
                // '">' +
                // value.partNumber +
                // "</a>",
                value.partNumber,
                packageId:value.packageId,
              partName: value.partName,
              updatedDate: dateFormatPipeFilter.transform(value.updatedDate),
              assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
              dueDated: dateFormatPipeFilter.transform(value.dueDate)
            };

            newPartArr = {
              partNumber: value.partNumber,
              packageId: value.packageId,
              partName: value.partName,
              updatedDate: dateFormatPipeFilter.transform(value.updatedDate),
              assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
              dueDated: dateFormatPipeFilter.transform(value.dueDate)
            };
            partsData.push(partArr);

            newPartArrData.push(newPartArr);
          });

          this.newPartsModelData = partsData;
          this.dataSource_newparts=new MatTableDataSource<NewParts[]>(this.newPartsModelData)
          
          this.newPartsAccData = newPartArrData;

          this.newpartslength = this.parts.response.totalElements;

          let filteredData = this.changeFilter(
            this.newPartsModelData,
            this.newPart_config,
            this.newPart_columns
          );
          let sortedData = this.changeSort(
            filteredData,
            this.newPart_config,
            this.newPart_columns
          );

          this.newPartsRow =
            page && config.paging
              ? this.changePage(page, sortedData)
              : sortedData;
          this.newPartsRow = this.rerenderTable(
            this.newPart_config,
            true,
            this.newPart_columns,
            partsData
          );
        }
        this.spinner.hide();
      });
  }

  public onChangeInprogressTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    var pageNo;
    var sortData = {
      name: "",
      sort: ""
    };

    var selectSuppCode = [],
      selectLineNo = [],
      userSuppCode,
      lineNumbers;

    var dateFormatPipeFilter = new dateFormatPipe();

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.inprogress_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.inprogress_config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.inprogress_config.sorting.columns.forEach(function(value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
        if (sortData.sort == "asc") {
          sortData.sort = "ASC";
        } else if (sortData.sort == "desc") {
          sortData.sort = "DESC";
        }
      }
    });

    //Get Selected Supplier Code
    if (this.userRoleID == 1) {
      this.userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function(value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    if (this.lineNoFilter) {
      this.lineNoFilter.forEach(function(value, key) {
        selectLineNo.push(value.itemName);
      });

      if (selectLineNo.length > 0) {
        lineNumbers = selectLineNo;
      }
    }

    if (lineNumbers == null) {
      lineNumbers = [];
    }

    var dataToSend = {
      pageNum: pageNo,
      partStatus: "inProgress",
      roleId: this.userRoleID,
      // searchValue: this.inprogress_config.filtering.filterString,
      searchValue:this.srch_inprogress,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      supplierCodes: this.userSuppCode,
      lineNumbers: lineNumbers
    };
    this.spinner.show();
    this.logbaseService
      .getNewPartsTodoPaginated(dataToSend)
      .subscribe(result => {
        this.parts = result;
        var partArr;
        var ipPartArr;
        var partsData = [];
        var ipArrData = [];

        this.parts.response.content.forEach(function(value, key) {
          partArr = {
            partNumber:
              // '<a class="partno_column" href="#/partDetails/partsInfo/' +
              // value.packageId +
              // '">' +
              // value.partNumber +
              // "</a>",
              value.partNumber,
              packageId:value.packageId,

            partName: value.partName,
            updatedDate: dateFormatPipeFilter.transform(value.updatedDate),
            assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
            dueDated: dateFormatPipeFilter.transform(value.dueDate)
          };

          ipPartArr = {
            partNumber: value.partNumber,
            packageId: value.packageId,
            partName: value.partName,
            updatedDate: dateFormatPipeFilter.transform(value.updatedDate),
            assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
            dueDated: dateFormatPipeFilter.transform(value.dueDate)
          };
          partsData.push(partArr);
          ipArrData.push(ipPartArr);
        });

        this.ipPartsModelData = partsData;
        this.dataSource_inprogress=new MatTableDataSource<InProgress[]>(this.ipPartsModelData)
        this.ipPartsAccData = ipArrData;

        this.ippartslength = this.parts.response.totalElements;

        let filteredData = this.changeFilter(
          this.ipPartsModelData,
          this.inprogress_config,
          this.inprogress_columns
        );
        let sortedData = this.changeSort(
          filteredData,
          this.inprogress_config,
          this.inprogress_columns
        );

        this.inProgressRow =
          page && config.paging
            ? this.changePage(page, sortedData)
            : sortedData;
        this.inProgressRow = this.rerenderTable(
          this.inprogress_config,
          true,
          this.inprogress_columns,
          partsData
        );

        this.spinner.hide();
      });
  }

  public onChangeUnderReviewTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    var pageNo;
    var sortData = {
      name: "",
      sort: ""
    };

    localStorage.setItem("todoSuppCode", JSON.stringify(this.supPoint));
    localStorage.setItem("todoLineNo", JSON.stringify(this.lineNoFilter));
    localStorage.setItem(
      "toDoDeliveryPoint",
      JSON.stringify(this.opmDeliveryPointFilter)
    );

    var dateFormatPipeFilter = new dateFormatPipe();
    var selectSuppCode = [],
      selectLineNo = [],
      userSuppCode,
      lineNumbers;

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.underReview_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.underReview_config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.underReview_config.sorting.columns.forEach(function(value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
        if (sortData.sort == "asc") {
          sortData.sort = "ASC";
        } else if (sortData.sort == "desc") {
          sortData.sort = "DESC";
        }
      }
    });

    //Get Selected Supplier Code
    if (this.userRoleID == 1) {
      this.userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function(value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    if (this.lineNoFilter) {
      this.lineNoFilter.forEach(function(value, key) {
        selectLineNo.push(value.itemName);
      });

      if (selectLineNo.length > 0) {
        lineNumbers = selectLineNo;
      }
    }

    var selectedDeliveryPoint = [];
    if (this.opmDeliveryPointFilter) {
      this.opmDeliveryPointFilter.forEach(function(value, key) {
        selectedDeliveryPoint.push(value.itemName);
      });
    }

    if (lineNumbers == null) {
      lineNumbers = [];
    }

    //var opsupplierCode=this.userDetJson.operationManagerSupplierCode;
    //var opDeliveryPoint=this.userDetJson.operationManagerdeliveryPointMaster;

    var supplierCodesOMArray = [];
    var deliveryPointOMArray = [];

    this.supplierCodeSelectionArray.forEach(obj => {
      supplierCodesOMArray.push(obj.itemName);
    });
    if (this.deliveryPointSelectionArray) {
      this.deliveryPointSelectionArray.forEach(obj => {
        deliveryPointOMArray.push(obj.itemName);
      });
    }

    if (this.userRoleID === 4 && this.userOperationType === OPERATION_TYPE) {
      supplierCodesOMArray = this.userDetJson.operationManagerSupplierCode;
      userSuppCode = [];
    }

    var dataToSend = {
      pageNum: pageNo,
      partStatus: "underReview",
      roleId: this.userRoleID,
      // searchValue: this.underReview_config.filtering.filterString,
      searchValue:this.srch_underReview,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      supplierCodes: userSuppCode,
      lineNumbers: lineNumbers,
      deliveryPoint: selectedDeliveryPoint,
      opMgrsupplierCodes: supplierCodesOMArray
    };
    console.log(dataToSend);
    this.spinner.show();
    this.logbaseService
      .getNewPartsTodoPaginated(dataToSend)
      .subscribe(result => {
        this.parts = result;
        var partArr;
        var urPartArr;
        var partsData = [];
        var urArrData = [];

        this.parts.response.content.forEach(function(value, key) {
          partArr = {
            partNumber:
              // '<a class="partno_column" href="#/partDetails/partsInfo/' +
              // value.packageId +
              // '">' +
              // value.partNumber +
              // "</a>",
              value.partNumber,
              packageId:value.packageId,
              
            partName: value.partName,
            updatedDate: dateFormatPipeFilter.transform(value.updatedDate),
            assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
            dueDated: dateFormatPipeFilter.transform(value.dueDate)
          };

          urPartArr = {
            partNumber: value.partNumber,
            packageId: value.packageId,
            partName: value.partName,
            updatedDate: dateFormatPipeFilter.transform(value.updatedDate),
            assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
            dueDated: dateFormatPipeFilter.transform(value.dueDate)
          };
          partsData.push(partArr);
          urArrData.push(urPartArr);
        });

        this.urPartsModelData = partsData;
        this.dataSource_underReview=new MatTableDataSource<UnderReview[]>(this.urPartsModelData)
        this.urPartsAccData = urArrData;

        this.urpartslength = this.parts.response.totalElements;

        let filteredData = this.changeFilter(
          this.urPartsModelData,
          this.underReview_config,
          this.underReview_columns
        );
        let sortedData = this.changeSort(
          filteredData,
          this.underReview_config,
          this.underReview_columns
        );

        this.underReviewRow =
          page && config.paging
            ? this.changePage(page, sortedData)
            : sortedData;
        this.underReviewRow = this.rerenderTable(
          this.underReview_config,
          true,
          this.underReview_columns,
          partsData
        );

        this.spinner.hide();
      });
  }

  public onChangeRejectedTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    var pageNo;
    var sortData = {
      name: "",
      sort: ""
    };

    var dateFormatPipeFilter = new dateFormatPipe();

    var selectSuppCode = [],
      selectLineNo = [],
      userSuppCode,
      lineNumbers;

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.rejected_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.rejected_config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.rejected_config.sorting.columns.forEach(function(value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
        if (sortData.sort == "asc") {
          sortData.sort = "ASC";
        } else if (sortData.sort == "desc") {
          sortData.sort = "DESC";
        }
      }
    });

    //Get Selected Supplier Code
    if (this.userRoleID == 1) {
      this.userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function(value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    if (this.lineNoFilter) {
      this.lineNoFilter.forEach(function(value, key) {
        selectLineNo.push(value.itemName);
      });

      if (selectLineNo.length > 0) {
        lineNumbers = selectLineNo;
      }
    }

    if (lineNumbers == null) {
      lineNumbers = [];
    }

    var dataToSend = {
      pageNum: pageNo,
      partStatus: "rejected",
      roleId: this.userRoleID,
      // searchValue: this.rejected_config.filtering.filterString,
      searchValue:this.srch_rejected,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      supplierCodes: userSuppCode,
      lineNumbers: lineNumbers
    };
    this.spinner.show();
    this.logbaseService
      .getNewPartsTodoPaginated(dataToSend)
      .subscribe(result => {
        this.parts = result;
        var partArr;
        var rejPartArr;
        var partsData = [];
        var rejArrData = [];

        this.parts.response.content.forEach(function(value, key) {
          partArr = {
            partNumber:
              // '<a class="partno_column" href="#/partDetails/partsInfo/' +
              // value.packageId +
              // '">' +
              // value.partNumber +
              // "</a>",
              value.partNumber,
              packageId:value.packageId,
            partName: value.partName,
            updatedDate: dateFormatPipeFilter.transform(value.updatedDate),
            assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
            comments: value.rejectedComments
          };

          rejPartArr = {
            partNumber: value.partNumber,
            packageId: value.packageId,
            partName: value.partName,
            updatedDate: dateFormatPipeFilter.transform(value.updatedDate),
            assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
            dueDated: dateFormatPipeFilter.transform(value.dueDate),
            comments: value.rejectedComments
          };
          partsData.push(partArr);
          rejArrData.push(rejPartArr);
        });

        this.rejPartsModelData = partsData;
        this.dataSource_rejected=new MatTableDataSource<Rejected[]>(this.rejPartsModelData)
        this.rejPartsAccData = rejArrData;

        this.rej_length = this.parts.response.totalElements;

        let filteredData = this.changeFilter(
          this.rejPartsModelData,
          this.rejected_config,
          this.rejected_columns
        );
        let sortedData = this.changeSort(
          filteredData,
          this.rejected_config,
          this.rejected_columns
        );

        this.rejectedRow =
          page && config.paging
            ? this.changePage(page, sortedData)
            : sortedData;
        this.rejectedRow = this.rerenderTable(
          this.rejected_config,
          true,
          this.rejected_columns,
          partsData
        );

        this.spinner.hide();
      });
  }

  public rerenderTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage },
    tableColumn: any,
    tableData: any
  ): any {
    // if (config.filtering) {
    //   Object.assign(this.config.filtering, config.filtering);
    // }
    // if (config.sorting) {
    //   Object.assign(this.config.sorting, config.sorting);
    // }
    let filteredData = this.changeFilter(tableData, config, tableColumn);
    let sortedData = this.changeSort(filteredData, config, tableColumn);
    return page && config.paging
      ? this.changePage(page, sortedData)
      : sortedData;
  }

  onCellClick(data: any) {
    this.modalRef.close();
  }

  closeModal() {
    this.modalRef.close();
  }

  public beforeChange(panelId:any) {
    if (panelId === "cdk-accordion-child-0" ) {
      this.onChangeNewPartTable(this.newPart_config, true);
    }

    if (panelId === "cdk-accordion-child-1") {
      this.onChangeInprogressTable(this.inprogress_config, true);
    }

    if (panelId === "cdk-accordion-child-3" ) {
      this.onChangeRejectedTable(this.rejected_config, true);
    }
  }

  onNextProcessChange(option) {
    // this.ovarAllAction=true;
    this.supplierCodeSelectionArray = [];
    this.deliveryPointSelectionArray = [];
    this.opmDSupplierCodeFilter = [];
    this.opmDeliveryPointFilter = [];
    if (option == null || option == "") {
      this.disableNextProcessSearch = true;
    } else {
      this.disableNextProcessSearch = false;
    }
    if (this.lineNoFilter.length == 0) this.disableNextProcessSearch = true;
  }

  onOMSupplierCodeChange(option) {
    this.disableNextProcessSearch = true;
    this.lineNoFilter = [];
    if (option != null && option != "")
      this.supplierCodeSelectionArray.push(option);
    if (
      this.deliveryPointSelectionArray &&
      this.deliveryPointSelectionArray.length > 0 &&
      this.supplierCodeSelectionArray.length > 0
    )
      this.ovarAllAction = false;
    else this.ovarAllAction = true;
    if (this.lineNoFilter.length == 0) this.disableNextProcessSearch = true;
  }

  onOMSupplierCodeChangeDeselect(option) {
    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.supplierCodeSelectionArray.indexOf(option);
    this.supplierCodeSelectionArray.splice(index, 1);
    if (
      this.deliveryPointSelectionArray &&
      this.deliveryPointSelectionArray.length > 0 &&
      this.supplierCodeSelectionArray.length > 0
    )
      this.ovarAllAction = false;
    else this.ovarAllAction = true;
  }

  onOMDeliveryPointChange(option) {
    this.disableNextProcessSearch = true;
    this.lineNoFilter = [];
    let deliveryPointselectionArr: any = [];
    if (this.deliveryPointSelectionArray == null)
      this.deliveryPointSelectionArray = [];
    if (option != null && option != "")
      this.deliveryPointSelectionArray.push(option);

    if (this.deliveryPointSelectionArray.length > 0) this.ovarAllAction = false;
    else this.ovarAllAction = true;
    /* if(this.lineNoFilter.length==0)
    this.disableNextProcessSearch = true;*/
  }

  onOMDeliveryPointChangeDeselect(option) {
    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.deliveryPointSelectionArray.indexOf(option);
    this.deliveryPointSelectionArray.splice(index, 1);
    if (this.deliveryPointSelectionArray.length > 0) this.ovarAllAction = false;
    else this.ovarAllAction = true;
  }

  initPagingtable() {
    //Load New part table if it is supplier else load data for under review table for other users
    if (this.userRoleID == 1) {
      this.onChangeNewPartTable(this.newPart_config, true);
      // To open only new parts accordion and close other accordion
      this.activeIds = ["static-1"];
    } else {
      this.onChangeUnderReviewTable(this.underReview_config, true);
      // To open only new parts accordion and close other accordion
      this.activeIds = ["static-3"];
    }
  }
}
